import React from "react";
import moment from "moment";
// import Logo from "./tempPic/logo.png";
import ProfileBox from "../../Components/ProfileBox/ProfileBox";

require("./Dashboard.css");

const NextExpectedPayment = ({ role }) => {
  const getNextPayDate = (startDate) => {
    const previousPaymentDate = new Date(startDate);
    previousPaymentDate.setDate(previousPaymentDate.getDate() - 14);
    const nextPaymentDate = new Date(startDate);
    const today = new Date()
    for (let i = 0; i < 1000; i++) {
      previousPaymentDate.setDate(previousPaymentDate.getDate() + 14);
      nextPaymentDate.setDate(nextPaymentDate.getDate() + 14);
      // console.log(nextPaymentDate)
      if (previousPaymentDate <= today && today <= nextPaymentDate) {
        return moment(nextPaymentDate).format("dddd Do MMMM")
      }
    }
  }

  const getNextSuperDate = (dueDate1, dueDate2, dueDate3, dueDate4) => {
    const today = new Date()
    const year = today.getFullYear();
    const dueDate_1 = new Date(dueDate1).setFullYear(year)
    const dueDate_2 = new Date(dueDate2).setFullYear(year)
    const dueDate_3 = new Date(dueDate3).setFullYear(year)
    const dueDate_4 = new Date(dueDate4).setFullYear(year)
    if (dueDate_1 < today && today <= dueDate_2) {
      return moment(dueDate_2).format("DD MMMM")
    } else if (dueDate_2 < today && today <= dueDate_3) {
      return moment(dueDate_3).format("DD MMMM")
    } else if (dueDate_3 < today && today <= dueDate_4) {
      return moment(dueDate_4).format("DD MMMM")
    } else {
      return moment(dueDate_1).format("DD MMMM")
    }
  }

  return (
    <ProfileBox
      header="Next Payment"
    >
      {role === "teacher" && <div className='text-left' style={{ fontSize: "16px" }}>
        <div className="flex mb-2">
          <p className="col">
            {getNextPayDate("2023-02-03") || undefined}
          </p>
          <a
            className="col"
            href="https://docs.google.com/spreadsheets/d/1mcJkcBQ0zUgwO4jPMy0eXvosI3iD8yBmVCNrc7z1qgE/edit#gid=197755259"
            target="_blank"
            style={{ color: "#4183c4" }}
          >
            View pay calendar
          </a>
        </div>
        <div className="flex" style={{ fontSize: "14px" }}>
          <p className="col">
            <i>
              Superannuation - {getNextSuperDate("2023-01-28", "2023-04-28", "2023-07-28", "2023-10-28")}
            </i>
          </p>
          <a
            className="col"
            href="https://www.ato.gov.au/business/super-for-employers/paying-super-contributions/super-payment-due-dates"
            target="_blank"
            style={{ color: "#4183c4" }}
          >
            <i>View Super calendar</i>
          </a>
        </div>
      </div>}
    </ProfileBox>
  );
};

export default NextExpectedPayment;


{/* <div className="flex shadow m-3 p-4 rounded">
      <div>
        <img
          className="shadow-md imageSize"
          src={Logo}
          alt="Logo"
        />
      </div>
      <div className="w-1/3 mx-auto flex flex-col justify-center">
        <h3>$520</h3>
        <p className="card-content">12 teaching hours</p>
        <p className="card-content">4 non teaching hours</p>
      </div>
      <div className="w-1/3 mx-auto flex flex-col justify-center">
        <h3>
          <Moment format="DD MMMM">28 May</Moment>
        </h3>
        <p className="card-content">*approximately</p>
      </div>
    </div> */}
